import { BlockType } from '@lighthouse/core'
import { BlockThumbImageMap, BlockTypeIconMap } from '@lighthouse/shared'

import type { BlockTreeItem } from '../type'

export const blockFilter: BlockTreeItem = {
    name: '筛选控制器',
    icon: BlockTypeIconMap.filter,
    describeImage: BlockThumbImageMap['filter'],
    color: '#5551FF',
    backGroundColor: 'rgba(85, 81, 255, 0.10)',
    type: BlockType.filter
}

export const blockTabs: BlockTreeItem = {
    name: '标签栏',
    icon: BlockTypeIconMap.tabs,
    describeImage: BlockThumbImageMap['tabs'],
    color: '#5551FF',
    backGroundColor: 'rgba(85, 81, 255, 0.10)',
    type: BlockType.tabs
}

export const blockToc: BlockTreeItem = {
    name: '笔记目录',
    icon: BlockTypeIconMap.toc,
    describeImage: BlockThumbImageMap['toc'],
    color: '#667085',
    backGroundColor: 'rgba(102, 112, 133, 0.10)',
    type: BlockType.toc
}
